const content = document.getElementById('content');
const toggleBtn = document.getElementById('toggleBtn');

function toggleContent() {
    const isExpanded = content.classList.toggle('expanded');
    toggleBtn.classList.toggle('expanded', isExpanded);

    if (isExpanded) {
        toggleBtn.innerHTML = 'Read Less <span class="chevron"></span>';
        toggleBtn.querySelector('.chevron').classList.add('expanded');
    } else {
        toggleBtn.innerHTML = 'Read More <span class="chevron"></span>';
    }
}

if(toggleBtn) toggleBtn.addEventListener('click', toggleContent);


// VIDEO 
{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".bgVideo");
    const allVideos = document.querySelectorAll(".bgVideo video");
    function pauseAllVideos() {
      allVideos.forEach((video) => {
        video.pause();
        const playIcon = video
          .closest(".bgVideo")
          .querySelector(".vid-play-pause-par");
        playIcon.style.display = "block";
      });
    }
    if(videoBoxes){
      videoBoxes.forEach((box) => {
        const video = box.querySelector("video");
        const playIcon = box.querySelector(".vid-play-pause-par");
        box.addEventListener("click", function () {
          if (video.paused) {
            pauseAllVideos();
            video.play();
            playIcon.style.display = "none";
          } else {
            video.pause();
            playIcon.style.display = "flex";
          }
        });
        video.addEventListener("play", function () {
          playIcon.style.display = "none";
        });
        video.addEventListener("pause", function () {
          playIcon.style.display = "flex";
        });
      });
    }
  });
}
{
  document.addEventListener('DOMContentLoaded', () => {
    let article_content = document.querySelectorAll('.article__body.rte p');
    if(article_content){
      article_content.forEach(p => {
        if(p.innerHTML.trim() == '&nbsp;'){
          p.style.display = 'none';
        }
      })
    }
    
  })
}

{
  document.addEventListener("DOMContentLoaded", function () {
    function faqsAccordion() {
      var accordionSections = document.querySelectorAll(".accordion-item");

      if (accordionSections.length > 0) {
        var firstAccordionItemHeader = accordionSections[0].querySelector(
          ".accordion-item-header"
        );
        var firstAccordionItemBody =
          firstAccordionItemHeader.nextElementSibling;

        if (firstAccordionItemBody) {
          firstAccordionItemHeader.classList.add("active");
          firstAccordionItemBody.style.maxHeight =
            firstAccordionItemBody.scrollHeight + "px";
        }

        for (let i = 1; i < accordionSections.length; i++) {
          var otherHeader = accordionSections[i].querySelector(
            ".accordion-item-header"
          );
          var otherBody = otherHeader.nextElementSibling;

          if (otherBody) {
            otherHeader.classList.remove("active");
            otherBody.style.maxHeight = "0";
          }
        }
      }

      accordionSections.forEach((section) => {
        var accordionItemHeaders = section.querySelector(
          ".accordion-item-header"
        );
        var accordionItemBody = section.querySelector(".accordion-item-body");

        accordionItemHeaders.addEventListener("click", function () {
          var currentlyActiveHeader = document.querySelector(
            ".accordion-item-header.active"
          );
          var currentlyActiveBody = currentlyActiveHeader
            ? currentlyActiveHeader.nextElementSibling
            : null;

          if (currentlyActiveHeader && currentlyActiveBody) {
            currentlyActiveHeader.classList.remove("active");
            currentlyActiveBody.style.maxHeight = 0;
          }

          if (accordionItemHeaders !== currentlyActiveHeader) {
            accordionItemHeaders.classList.add("active");
            accordionItemBody.style.maxHeight =
              accordionItemBody.scrollHeight + "px";
          } else {
            accordionItemHeaders.classList.remove("active");
            accordionItemBody.style.maxHeight = 0;
          }
        });
      });
    }

    faqsAccordion();
  });
}